import { WidgetChartType } from '@/dashboard/shared/types/widgets.types';
import { ChartOptions } from '../../widgets/common/types/widgets.types';
import { ReferenceInfo } from '../../widgetSettings/editModeWidgetSettings/components/common/referenceSettingOption/referenceSettingOption.setup';

export const isWidgetReferenceGlobalTimePeriod = <T extends WidgetChartType>(
  chartOption: ChartOptions<T>,
): boolean => {
  return (
    !!chartOption &&
    !!chartOption.referenceInfo &&
    Object.values(chartOption.referenceInfo as ReferenceInfo).some((variableList) =>
      variableList?.some(({ value }) => value?.type === 'globalTimePeriod'),
    )
  );
};
